import { copy } from "shared/assets";
import { IUserPermissions } from "shared/utils";
import { IStatus } from "shared/types";
import { IActionDropdownItem } from "shared/components";

const { actions: actionsCopy } = copy;

export const getInfoBlockActions = ({
  userPermissions,
  handleDelete,
  handleEdit,
  openSuggestEditModal,
}: {
  userPermissions: IUserPermissions;
  handleEdit: () => void;
  handleDelete: () => void;
  openSuggestEditModal: () => void;
}): IActionDropdownItem[] => {
  const actions: IActionDropdownItem[] = [];

  if (userPermissions.EDIT) {
    actions.push({
      label: actionsCopy.edit,
      handleClick: handleEdit,
    });
  }
  if (userPermissions.DELETE) {
    actions.push({
      label: actionsCopy.delete,
      status: IStatus.error,
      handleClick: handleDelete,
      dataTestId: "delete_info_block",
    });
  }

  if (actions.length !== 0) {
    return actions;
  }

  return [
    {
      label: actionsCopy.suggestEdit,
      handleClick: openSuggestEditModal,
      dataTestId: "suggest_edit",
    },
  ];
};
